export function parseCurrentUrlAndGetYear() {
    var paths:string[] = location.pathname.split('/');
    return Number(paths[1]);
}


// WEBPACK FOOTER //
// ./src/app/shared/helpers.util.ts